"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegistrationHistoryFilterCollection = exports.registrationHistorySortFilterGroup = exports.registrationHistorySourceFilterGroup = exports.registrationHistoryStatusFilterGroup = void 0;
const Status_1 = __importDefault(require("@Components/Status"));
const suggestion_status_1 = require("@Components/MatchComponents/v2/suggestion-status");
const react_1 = __importDefault(require("react"));
const form_field_types_1 = require("@App/enum/form-field-types");
exports.registrationHistoryStatusFilterGroup = {
    name: 'Submission Status',
    allowMultiple: true,
    filterFields: [
        {
            ACCEPTED: {
                type: form_field_types_1.FormFieldTypes.CHECKBOX,
                checked: false,
                name: 'accepted',
                label: '',
                children: react_1.default.createElement(Status_1.default, { withCount: false, status: suggestion_status_1.SUGGESTION_STATUS_VALUES.ACCEPTED, big: true }),
            },
        },
        {
            REJECTED: {
                type: form_field_types_1.FormFieldTypes.CHECKBOX,
                checked: false,
                name: 'rejected',
                label: '',
                children: react_1.default.createElement(Status_1.default, { withCount: false, status: suggestion_status_1.SUGGESTION_STATUS_VALUES.REJECTED, big: true }),
            },
        },
        {
            SUPERSEDED: {
                type: form_field_types_1.FormFieldTypes.CHECKBOX,
                checked: false,
                name: 'superseded',
                label: '',
                children: react_1.default.createElement(Status_1.default, { withCount: false, status: suggestion_status_1.SUGGESTION_STATUS_VALUES.SUPERSEDED, big: true }),
            },
        },
    ],
};
exports.registrationHistorySourceFilterGroup = {
    name: 'Submission Source',
    allowMultiple: true,
    filterFields: [
        {
            CWR: {
                type: form_field_types_1.FormFieldTypes.CHECKBOX,
                checked: false,
                name: 'cwr',
                label: '',
                children: react_1.default.createElement("strong", null, " CWR "),
            },
        },
        {
            ESONG: {
                type: form_field_types_1.FormFieldTypes.CHECKBOX,
                checked: false,
                name: 'esong',
                label: '',
                children: react_1.default.createElement("strong", null, " eSong "),
            },
        },
        {
            MLC: {
                type: form_field_types_1.FormFieldTypes.CHECKBOX,
                checked: false,
                name: 'mlc',
                label: '',
                children: react_1.default.createElement("strong", null, " The MLC "),
            },
        },
    ],
};
exports.registrationHistorySortFilterGroup = {
    name: 'Sort',
    allowMultiple: false,
    filterFields: [
        {
            SORT: {
                type: form_field_types_1.FormFieldTypes.RADIO,
                options: [
                    { name: 'submission_date', label: 'Submission Date' },
                    { name: 'last_update_date', default: true, label: 'Last Updated' },
                ],
                name: 'sort_by',
                label: '',
                children: react_1.default.createElement("strong", null, " Submission Date "),
            },
        },
    ],
};
exports.RegistrationHistoryFilterCollection = [
    exports.registrationHistoryStatusFilterGroup,
    exports.registrationHistorySourceFilterGroup,
    exports.registrationHistorySortFilterGroup,
];
